import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  bulkInventoryBinService,
  type UpdateConditionCodeRequest,
  type UpdateConditionCodeResponse,
} from '@/services/propertyBook/BulkInventoryBinService';
import { queryKeys } from '@/lib/queryKeys';

export const useUpdateBinConditionCode = () => {
  const queryClient = useQueryClient();

  return useMutation<UpdateConditionCodeResponse, unknown, UpdateConditionCodeRequest>({
    mutationFn: (payload) => bulkInventoryBinService.updateConditionCode(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.bulkInventoryBin.pendingDisposal(),
      });
      void queryClient.invalidateQueries({ queryKey: queryKeys.entities.lists() });
    },
  });
};
